import {Directive,HostListener} from '@angular/core'

@Directive({
	selector: '[phoneMask]'
})
export class PhoneDirective {

	@HostListener('input', ['$event'])
	onKeyDown(event: KeyboardEvent) {
		const input = event.target as HTMLInputElement;
		
		// remove spaces
		let trimmed = input.value.replace(/\s+/g, '');

		input.value = this.GetInputValue( trimmed );
		
	}

	public GetInputValue( v : string ) : string {
		

		// trim '-' dashes
		v = v.replace(/-/g,'');

		v = v.replace(/[^\d]/g, "");
		
		// trim string to 15 characters
		if( v.length > 10) {
			if (v.length > 15) {
				v = v.substr(0, 15);
			}
			return '   +' + v;
		}
		

    // new array to hold sections of the License Key
		let numbers = [];

		// create set of characters from first 5 characters
		numbers.push(v.substr(0,3));
		
		// try for next 5
		if(v.substr(3,3)!=="")
			numbers.push(v.substr(3,3));
		
		// and last set of 5
		if(v.substr(6,10)!="")
			numbers.push(v.substr(6,4));
		
		if(v.substr(10,15)!="")
			numbers.push(v.substr(10,5));

		// add '-' dashes back to formated string
		let newValue = numbers[0];
		
		//if( newValue.length == 3 ) {
			
		//}

		if( numbers.length > 1 ) {
			newValue = '(' + newValue + ') ';
			newValue += numbers[1];
		}
			

		if (numbers.length > 2 )
			newValue += '-' + numbers[2];

		// if (numbers.length > 3 )
		// 	newValue += '-' + numbers[3];

		return newValue;
	}

}
